export const tones = [
  { value: "Neutral", label: "Neutral" },
  { value: "Casual", label: "Casual" },
  { value: "Friendly", label: "Friendly" },
  { value: "Sarcastic", label: "Sarcastic" },
  { value: "Formal", label: "Formal" },
  { value: "Informative", label: "Informative" },
  { value: "Direct", label: "Direct" }
];